import Swiper from 'swiper/bundle';

class UTFeatureItems {
  constructor() {
    this.wrapper = document.querySelector("[data-role='ut-feature-items']");

    if (!this.wrapper) return;

    this.swiperElm = this.wrapper.querySelector("[data-role='ut-features-swiper']");
    this.swiperNext = this.wrapper.querySelector("[data-role='ut-features-swiper-next']");
    this.swiperPrev = this.wrapper.querySelector("[data-role='ut-features-swiper-prev']");

    if (!this.swiperElm || !this.swiperNext || !this.swiperPrev) return;

    this.slides = this.swiperElm.querySelectorAll('.swiper-slide');
    this.slideCount = this.slides.length;

    this.isLackingSlide = this.slides.length <= 1 ? true : false;
    this.isLoop = !this.isLackingSlide;

    // initial for lacking slides case
    if (this.isLackingSlide) {
      this.swiperNext.style.display = 'none';
      this.swiperPrev.style.display = 'none';
    }

    this.swiper = new Swiper(this.swiperElm, {
      slidesPerView: 1.5,
      spaceBetween: 2,
      loop: this.isLoop,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 12,
        },
      },
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev,
      },
    });
  }
}

export default UTFeatureItems;
